import React from "react";


const DisplayProp = ({value}) => {

    return (
        <span
            style={{
                minWidth: '100px',
                fontStyle: 'italic',
            }}
        >{value}</span>
    )
}

export default DisplayProp